import api from 'app/shared/utils/api';
import promise from 'promise';
import DispatchConstants from 'app/shared/constants/DispatchConstants';
import EmailVerification from 'app/shared/model/EmailVerification';

import appLogger from 'app/shared/loggers/appLogger';

const EmailVerificationActions = {
    getUnverifiedEmailFeedListings(limit) {
        const data = {};

        if (limit) {
            data.limit = limit;
        }

        return dispatch => dispatch(api.users.emailVerification.unverifiedEmailFeedListings(data))
            .then((response) => {
                if (response.success && response.response) {
                    const emailVerificationModel = EmailVerification(response.response);

                    dispatch(EmailVerificationActions.updateEmailVerificationInfo(emailVerificationModel));
                    return emailVerificationModel;
                }
                return promise.reject(response.error);
            });
    },
    sendSecurityToken(data) {
        return dispatch => dispatch(api.users.emailVerification.sendSecurityToken(data))
            .then((response) => {
                if (response.success && response.response) {
                    return response;
                }
                return promise.reject(response.error);
            }).catch((errorRMWModel) => {
                appLogger.logError({
                    message: errorRMWModel.message,
                    context: 'EmailVerificationActions.sendSecurityToken',
                });
            });
    },
    verifySecurityToken(token) {
        return dispatch => dispatch(api.users.emailVerification.verifySecurityToken(token))
            .then((response) => {
                if (response.success) {
                    return response;
                }
                return promise.reject(response);
            }).catch((errorRMWModel) => {
                appLogger.logError({
                    message: errorRMWModel.message,
                    context: 'EmailVerificationActions.verifySecurityToken',
                });
                return promise.reject(errorRMWModel.error);
            });
    },
    updateEmailVerificationInfo(data) {
        return dispatch => dispatch({
            type: DispatchConstants.UPDATE_EMAIL_VERIFICATION,
            payload: data,
        });
    },
};

export default EmailVerificationActions;
